










import { Component, Vue } from 'vue-property-decorator';
import { Action } from "vuex-class";

import SignIn from '@/components/auth/SignIn.vue';

@Component({
  components: {
    SignIn,
  },
})
export default class HomeScreen extends Vue {
  @Action("app/resetAllStates")
  public resetAllStates: () => Promise<void>;

  public mounted() {
    this.resetAllStates();
  }
}
